"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M23.105 32.025a2 2 0 0 0 1.789 0L40 24.472V30c0 4.418-7.163 10-16 10a20.293 20.293 0 0 1-12-3.845v-9.683z" }),
  React.createElement("path", { d: "M4 18l-2.211-1.106a1 1 0 0 1 0-1.789L23.106 4.447a2 2 0 0 1 1.789 0l21.316 10.659a1 1 0 0 1 0 1.789L24.89 27.555a2 2 0 0 1-1.782 0L12.315 22.21l9.29-4.82A4.878 4.878 0 0 0 24 18c2.209 0 4-1.343 4-3s-1.791-3-4-3a4.1 4.1 0 0 0-3.739 1.963L8 20v15.02a30 30 0 0 0 .586 5.9l1.374 4.69A2 2 0 0 1 8 48H4a2 2 0 0 1-1.958-2.409l1.39-4.717A30 30 0 0 0 4 35.07z" })
);

